/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CallSession } from './CallSession';
import {
    CallSessionFromJSON,
    CallSessionFromJSONTyped,
    CallSessionToJSON,
    CallSessionToJSONTyped,
} from './CallSession';

/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    ownerId: number;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    type: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Campaign
     */
    participantsIds?: Array<number> | null;
    /**
     * Liste des callSessions liées à la campagne
     * @type {Array<CallSession>}
     * @memberof Campaign
     */
    callSessions: Array<CallSession> | null;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    clientsSessionsMade: number;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    clientsSessionsToMake: number;
}

/**
 * Check if a given object implements the Campaign interface.
 */
export function instanceOfCampaign(value: object): value is Campaign {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('callSessions' in value) || value['callSessions'] === undefined) return false;
    if (!('clientsSessionsMade' in value) || value['clientsSessionsMade'] === undefined) return false;
    if (!('clientsSessionsToMake' in value) || value['clientsSessionsToMake'] === undefined) return false;
    return true;
}

export function CampaignFromJSON(json: any): Campaign {
    return CampaignFromJSONTyped(json, false);
}

export function CampaignFromJSONTyped(json: any, ignoreDiscriminator: boolean): Campaign {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ownerId': json['owner_id'],
        'companyId': json['company_id'],
        'startDate': json['start_date'] == null ? undefined : json['start_date'],
        'endDate': json['end_date'] == null ? undefined : json['end_date'],
        'state': json['state'] == null ? undefined : json['state'],
        'type': json['type'],
        'participantsIds': json['participants_ids'] == null ? undefined : json['participants_ids'],
        'callSessions': (json['call_sessions'] == null ? null : (json['call_sessions'] as Array<any>).map(CallSessionFromJSON)),
        'clientsSessionsMade': json['clients_sessions_made'],
        'clientsSessionsToMake': json['clients_sessions_to_make'],
    };
}

export function CampaignToJSON(json: any): Campaign {
    return CampaignToJSONTyped(json, false);
}

export function CampaignToJSONTyped(value?: Campaign | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'owner_id': value['ownerId'],
        'company_id': value['companyId'],
        'start_date': value['startDate'],
        'end_date': value['endDate'],
        'state': value['state'],
        'type': value['type'],
        'participants_ids': value['participantsIds'],
        'call_sessions': (value['callSessions'] == null ? null : (value['callSessions'] as Array<any>).map(CallSessionToJSON)),
        'clients_sessions_made': value['clientsSessionsMade'],
        'clients_sessions_to_make': value['clientsSessionsToMake'],
    };
}

